import {
  useFeatureGate,
  useGetExperimentValue,
} from '@trello/feature-gate-client';

interface HookProps {
  shouldFireExposureEvent?: boolean;
}

export const useIsCardBackRedesignEnabled = ({
  shouldFireExposureEvent = false,
}: HookProps = {}) => {
  const { value: isOverrideGateEnabled } = useFeatureGate(
    'phx_card_back_redesign',
  );

  const { value: isPersonalProductivityEnabled } = useFeatureGate(
    'trello_personal_productivity_release',
  );

  const { cohort: existingUserCohort } = useGetExperimentValue({
    experimentName: 'trello_phoenix_card_back_redesign_existing_users',
    parameter: 'cohort',
    fireExposureEvent: isPersonalProductivityEnabled && shouldFireExposureEvent,
  });

  const { cohort: newUserCohort } = useGetExperimentValue({
    experimentName: 'trello_phoenix_card_back_redesign_new_users',
    parameter: 'cohort',
    fireExposureEvent: isPersonalProductivityEnabled && shouldFireExposureEvent,
  });

  const isRedesignEnabled =
    isOverrideGateEnabled ||
    existingUserCohort === 'experiment' ||
    newUserCohort === 'experiment';

  return isRedesignEnabled && isPersonalProductivityEnabled;
};
